import React, { FC } from 'react'

type IconProps = {
  className?: string
}

export const PauseIcon: FC<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={'16'}
      viewBox={'0 0 16 16'}
      width={'16'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M5.2 4.39995V11.6H6.4V4.39995H5.2ZM4 4.39995C4 3.74995 4.525 3.19995 5.2 3.19995H6.4C7.05 3.19995 7.6 3.74995 7.6 4.39995V11.6C7.6 12.275 7.05 12.8 6.4 12.8H5.2C4.525 12.8 4 12.275 4 11.6V4.39995ZM9.6 4.39995V11.6H10.8V4.39995H9.6ZM8.4 4.39995C8.4 3.74995 8.925 3.19995 9.6 3.19995H10.8C11.45 3.19995 12 3.74995 12 4.39995V11.6C12 12.275 11.45 12.8 10.8 12.8H9.6C8.925 12.8 8.4 12.275 8.4 11.6V4.39995Z'
        }
        fill={'currentColor'}
      />
    </svg>
  )
}
